<template>
  <div></div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import { i18n } from '@/locales'

@Component({
  name: 'TOOL_COMPANY_BASE'
})
export default class TOOL_COMPANY_BASE extends Vue {
  /**
   * 会社登録ツール管理画面ツールチップタイプ
   */
  tooltipType: Record<string, string> = {
    // 戻る
    back: 'back',
    // 取消
    cancel: 'cancel',
    // 保存
    save: 'save',
    // 削除
    delete: 'delete'
  }
  /**
   * 画面ツールチップを取得する
   *
   * @param {string} key ツールチップキー
   * @returns {any} ツールチップ
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getTooltip(key: string): any {
    return {
      content: i18n.t(`gpsTracker.tooltipCommon.${key}`),
      placement: 'bottom-start',
      delay: { show: 1000, hide: 0 }
    }
  }
}
</script>
